import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {
  loadingmilestones: false,
};

export const fetchMilestones = createAsyncThunk(
  "milestoneSlice/fetchMilestones",
  async (id) => {
    const data = await apiService(API_ROUTES.FETCH_MILESTONES, "GET", {
      replace: { id },
    });
    return data;
  },
);

const milestoneSlice = createSlice({
  name: "milestoneSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMilestones.pending, () => {})
      .addCase(fetchMilestones.fulfilled, (state, { payload }) => {
        state.processmilestones = payload?.data;
      })
      .addCase(fetchMilestones.rejected, () => {});
  },
});
export default milestoneSlice.reducer;
